module.exports = __webpack_public_path__ + "media/images/aloe/icons/checkout/mastercard-444e035e74af0416916d03caecb4d2a9.svg";